<template>
  <div class="imagepreviewerssingle">
    <div class="previewsingle">
      <img v-if="profurl" :src="profurl" class="preimg" />

      <span class="iclass" @click="triggerchange">
         <div class="needsclick dropzone dropzonefull" id="document-dropzone" onclick="">
          <div class="dz-message" data-dz-message>
             <i class="fas fa-plus"></i>
          </div>
        </div>       
      </span>      

    </div>
  </div>
</template>
<style scoped>
.imagepreviewerssingle {
  position: relative;
  margin: auto;
  display: inline-block;
}
.userbanner {
  visibility: hidden;
}
.iclass {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
}
.iclass i {
  margin-top: 20%;
}
.preimg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.previewsingle {
  width: 150px;
  height: 150px;
  text-align: center;
  vertical-align: middle;
  margin: 7px;
  border-radius: 13%;
  background: #343436;
  position: relative;
}
.dropzonefull{
  padding: 0;
  min-height: inherit;
}

.dropzonefull .dz-preview{
  position: absolute;
    left: 0;
    top: 0;
    margin: 0;
    border-radius: 10px;
    padding: 7px 14px;
}
</style>
<script scoped>
export default {
  name: "imagepreview",
  props: ["avater", "banner"],
  data() {
    return {
      url: null,
      profurl: null,
    };
  },
  methods: {
    onSelectFile(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    triggerchange(e) {
      e.preventDefault();
      $("#profileimg").click();
    },

    onSelectProfileFile(e) {
      const file = e.target.files[0];
      this.profurl = URL.createObjectURL(file);
    },
    triggerProfilechange(e) {
      e.preventDefault();
      $("#profileimg").click();
    },
  },
  computed: {
    showModalFun() {
      return this.$store.state.loginmodal;
    },
  },
  created() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    if (this.avater !== "") {
      this.profurl = this.avater;
    }
  },
};
</script>
